export class PathsalaConfig {
  pathshalaCenters: any[];
  pathshalaClasses: any[];

  constructor(data: any) {
    data = data || {};
    this.pathshalaCenters = data.pathshalaCenters || [];
    this.pathshalaClasses = data.pathshalaClasses || [];
  }
}

export class ProgramId {
  _id: string;
  language: string;
  exam: string[];
  name: string;
  class: string;
  board: string;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.language = data.language || '';
    this.exam = data.exam || [];
    this.name = data.name || '';
    this.class = data.class || '';
    this.board = data.board || '';
  }
}

export class FeeId {
  _id: string;
  tax: number;
  discount: number;
  amount: number;
  total: number;
  price: number;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.tax = data.tax || '';
    this.discount = data.discount || '';
    this.amount = data.amount || '';
    this.total = data.total || '';
    this.price = data.price || '';
  }
}

export class PreviewImage {
  baseUrl: string;
  key: string;
  name: string;
  _id: string;

  constructor(data: any) {
    data = data || {};
    this.baseUrl = data.baseUrl || '';
    this.key = data.key || '';
    this.name = data.name || '';
    this._id = data._id || '';
  }
}

export class BatchId {
  _id: string;
  pathsalaConfig: PathsalaConfig;
  batchCategoryIds: string[];
  isCombo: boolean;
  byName: string;
  comboItems: any[];
  attachTestCat: boolean;
  testCats: any[];
  previewVideoType: string;
  type: string;
  isAvailableFromPoints: boolean;
  maxWalletPoint: number;
  enableStudyMaterial: boolean;
  referAndEarnStatus: boolean;
  isDoubtEnabled: boolean;
  isPathshala: boolean;
  markedAsNew: boolean;
  status: string;
  language: string;
  exam: any[];
  displayOrder: number;
  isTrending: boolean;
  isPocketCourse: boolean;
  isCashbackEnable: boolean;
  enableCommunity: boolean;
  enableSuper40: boolean;
  manualAllotmentCount: number;
  isKhazanaEnable: boolean;
  isFullYearCourse: boolean;
  isCrashCourse: boolean;
  cashbackType: string;
  cashbackValue: number;
  popularity: number;
  name: string;
  batchCode: string;
  organizationId: string;
  programId: ProgramId;
  feeId: FeeId;
  startDate: string;
  endDate: string;
  registrationStartDate: string;
  registrationEndDate: string;
  class: string;
  slug: string;
  isSelfLearning: boolean;
  buddyRoomId: string;
  createdAt: string;
  updatedAt: string;
  label: any[];
  meta: any[];
  studyMaterials: any[];
  previewImage: PreviewImage;
  teachers: Teachers[];
  priceLabel: string;
  description: string;
  startingPlan: FeeId;
  planCount: number;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.byName = data.byName || '';
    this.pathsalaConfig = new PathsalaConfig(data.pathsalaConfig) || new PathsalaConfig({});
    this.batchCategoryIds = data.batchCategoryIds || [];
    this.isCombo = data.isCombo || false;
    this.comboItems = data.comboItems || [];
    this.attachTestCat = data.attachTestCat || false;
    this.testCats = data.testCats || [];
    this.previewVideoType = data.previewVideoType || '';
    this.isAvailableFromPoints = data.isAvailableFromPoints || false;
    this.type = data.type || '';
    this.maxWalletPoint = data.maxWalletPoint || 0;
    this.enableStudyMaterial = data.enableStudyMaterial || false;
    this.referAndEarnStatus = data.referAndEarnStatus || false;
    this.isDoubtEnabled = data.isDoubtEnabled || false;
    this.isPathshala = data.isPathshala || false;
    this.markedAsNew = data.markedAsNew || false;
    this.status = data.status || '';
    this.language = data.language || '';
    this.exam = data.exam || [];
    this.displayOrder = data.displayOrder || 0;
    this.isTrending = data.isTrending || false;
    this.isPocketCourse = data.isPocketCourse || false;
    this.isCashbackEnable = data.isCashbackEnable || false;
    this.enableCommunity = data.enableCommunity || false;
    this.enableSuper40 = data.enableSuper40 || false;
    this.manualAllotmentCount = data.manualAllotmentCount || 0;
    this.isCashbackEnable = data.isCashbackEnable || false;
    this.isKhazanaEnable = data.isKhazanaEnable || false;
    this.isFullYearCourse = data.isFullYearCourse || false;
    this.isCrashCourse = data.isCrashCourse || false;
    this.cashbackType = data.cashbackType || '';
    this.cashbackValue = data.cashbackValue || 0;
    this.popularity = data.popularity || 0;
    this.name = data.name || '';
    this.batchCode = data.batchCode || '';
    this.organizationId = data.organizationId || '';
    this.programId = new ProgramId(data.programId) || new ProgramId({});
    this.feeId = new FeeId(data.feeId) || new FeeId({});
    this.startDate = data.startDate || '';
    this.endDate = data.endDate || '';
    this.registrationStartDate = data.registrationStartDate || '';
    this.registrationEndDate = data.registrationEndDate || '';
    this.class = data.class || '';
    this.slug = data.slug || '';
    this.isSelfLearning = data.isSelfLearning || false;
    this.buddyRoomId = data.buddyRoomId || '';
    this.createdAt = data.createdAt || '';
    this.updatedAt = data.updatedAt || '';
    this.label = data.label || [];
    this.meta = data.meta || [];
    this.studyMaterials = data.studyMaterials || [];
    this.priceLabel = data.priceLabel || '';
    this.description = data.description || '';
    this.previewImage = new PreviewImage(data.previewImage) || new PreviewImage({});
    this.startingPlan = new FeeId(data.startingPlan) || new FeeId({});
    this.planCount = data.planCount || 0;

    if (data.teachers) {
      this.teachers = data.teachers.map((teacher: any) => new Teachers(teacher));
    } else {
      this.teachers = [];
    }
  }
}

export class Teachers {
  _id: string;
  name: string;

  constructor(data: any) {
    data = data || {};

    this._id = data._id || '';
    this.name = data.name || '';
  }
}

export class Batch {
  _id: string;
  batchId: BatchId;
  cohortId: string;
  priority: number;
  status: string;

  constructor(data: any) {
    data = data || {};
    this._id = data._id || '';
    this.cohortId = data.cohortId || '';
    this.priority = data.priority || '';
    this.status = data.status || '';
    if (data.batchId) {
      this.batchId = new BatchId(data.batchId);
    } else {
      this.batchId = new BatchId({});
    }
  }
}
